export const LmsUserStatus = {
  Guest: "GUEST",
  Inactive: "INACTIVE",
  Not_approved: "NOT_APPROVED",
  Approved: "APPROVED",
} as const;

export type LmsUserStatus = (typeof LmsUserStatus)[keyof typeof LmsUserStatus];
